import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import '../../../content/css/RedflagComponent.css';
import 'react-dropdown-tree-select/dist/styles.css'
import CountryDropdownTreeSelect from './CountryDropdownTreeSelect';

export default class G1RedflagComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selection: props.category.customProperties ? JSON.parse(props.category.customProperties) : []
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.category !== this.props.category) {
            let selection = this.props.category.customProperties ? JSON.parse(this.props.category.customProperties) : [];
            this.setState({ selection });
        }
    }

    assignObjectPaths(obj, stack) {
        /*Object.keys(obj).forEach(k => {
            const node = obj[k];
            if (typeof node === "object") {
                node.path = stack ? `${stack}.${k}` : k;
                assignObjectPaths(node, node.path);
            }
        });*/
    }

    handleChange(data) {
        this.setState({ selection: data });
    }

    handleSave() {
        this.props.onSave(this.state.selection);
    }

    render() {
        return (
            <div className="G1-redflag">
                <div>
                    <span>Select all accepted jurisdictions. The rest will be assumed unaccepted and flagged when present in a contract.</span>
                    <CountryDropdownTreeSelect initialSelection={this.state.selection} onChange={this.handleChange} />
                </div>
                <Button className="save-btn" onClick={this.handleSave}>Save</Button>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/CategoryView/Redflag/G1RedflagComponent.js